import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import cookie from 'js-cookie'
import './plugins/element-ui'
import './assets/scss/reset.scss'
import globalMixin from './mixins/globalMixin'

Vue.config.productionTip = false
Vue.prototype.$cookie = cookie
Vue.prototype.$baseUrlImage = process.env.VUE_APP_URL_IMAGES
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL
Vue.mixin(globalMixin)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
